import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {ToggleMenuOnHoverDirective} from './toggle-menu-on-hover.directive';
import {LocalizedPipe} from './pipes/localized.pipe';
import {MatTableModule} from '@angular/material/table';
import {SearchBannerComponent} from './components/search-banner/search-banner.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatExpansionModule} from '@angular/material/expansion';
import {NotExistsPipe} from './pipes/not-exists.pipe';
import {ExistsPipe} from './pipes/exists.pipe';
import {HasLocalizableTextPipe} from './pipes/has-localizable-text.pipe';
import {NavigationCardComponent} from './components/navigation-card/navigation-card.component';
import {BannerComponent} from './components/banner/banner.component';
import {MatSortModule} from '@angular/material/sort';
import {MatPaginatorModule} from '@angular/material/paginator';
import {ValidInvalidIconComponent} from './components/valid-invalid-icon/valid-invalid-icon.component';
import {SearchResultTableColumnDirective} from './components/search-result-table/search-result-table-column.directive';
import {
	GetExtendedAccessTeaserComponent
} from './components/get-extended-access-teaser/get-extended-access-teaser.component';
import {PluckPipe} from './pipes/pluck.pipe';
import {ResourcePathPipe} from './pipes/resource-path.pipe';
import {HitCountStringComponent} from './components/hit-count-string/hit-count-string.component';
import {RouterModule} from '@angular/router';
import {StaticPageBlockComponent} from './components/static-page-block/static-page-block.component';
import {StaticBannerComponent} from '@app/shared/components/static-banner/static-banner.component';
import {MatMenuModule} from '@angular/material/menu';
import {ResultCardComponent} from './components/result-card/result-card.component';
import {IsNullOrEmptyPipe} from '@app/shared/pipes/is-null-or-empty.pipe';
import {SearchResultTableComponent} from '@app/shared/components/search-result-table/search-result-table.component';
import {MobileSortComponent} from '@app/shared/components/search-result-table/mobile-sort/mobile-sort.component';
import {MatInputModule} from '@angular/material/input';
import {MatChipsModule} from '@angular/material/chips';
import {MatAutocompleteModule} from '@angular/material/autocomplete';


@NgModule({
	imports: [
		CommonModule,
		MatIconModule,
		MatButtonModule,
		MatTableModule,
		MatExpansionModule,
		ReactiveFormsModule,
		FormsModule,
		MatSortModule,
		MatPaginatorModule,
		RouterModule,
		MatMenuModule,
		MatInputModule,
		MatChipsModule,
		MatAutocompleteModule
	],
	exports: [
		PluckPipe,
		MatIconModule,
		MatButtonModule,
		MatTableModule,
		ToggleMenuOnHoverDirective,
		SearchBannerComponent,
		LocalizedPipe,
		NotExistsPipe,
		ExistsPipe,
		HasLocalizableTextPipe,
		IsNullOrEmptyPipe,
		ResourcePathPipe,
		NavigationCardComponent,
		BannerComponent,
		SearchResultTableComponent,
		MobileSortComponent,
		ValidInvalidIconComponent,
		SearchResultTableColumnDirective,
		GetExtendedAccessTeaserComponent,
		HitCountStringComponent,
		StaticPageBlockComponent,
		StaticBannerComponent,
		ResultCardComponent
	],
	declarations: [
		ToggleMenuOnHoverDirective,
		SearchBannerComponent,
		LocalizedPipe,
		NotExistsPipe,
		ExistsPipe,
		HasLocalizableTextPipe,
		IsNullOrEmptyPipe,
		ResourcePathPipe,
		NavigationCardComponent,
		BannerComponent,
		SearchResultTableComponent,
		MobileSortComponent,
		ValidInvalidIconComponent,
		SearchResultTableColumnDirective,
		GetExtendedAccessTeaserComponent,
		PluckPipe,
		HitCountStringComponent,
		StaticPageBlockComponent,
		StaticBannerComponent,
		ResultCardComponent
	]
})
export class SharedModule {
}
